export const MUTATION_IMPORT_PRODUCT_TEMPLATE_DATA = `mutation importProductTemplateData($productData:[ProductPropertyTemplateDataImportInput!]!){
  importProductTemplateData(data: $productData)
}`